import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';

import SatButton from '@components/common/satUI/SatButton';

import {
  RECOMMEND_WON_FACEAMOUNT,
  RECOMMEND_DOLLAR_FACEAMOUNT,
  RECOMMEND_WON_PREMIUM,
  RECOMMEND_DOLLAR_PREMIUM,
} from '@common/constants';
import {
  toCurrency,
  toDateNumber,
  toFloatNumber,
  toNumber,
  toPhoneNumber,
} from '@common/utils/index';
import { isMobile } from '@common/utils/device';

const KEY_PAD = [
  { key: '1', value: 1, class: 'num', label: '1', fixed: true },
  { key: '2', value: 2, class: 'num', label: '2', fixed: true },
  { key: '3', value: 3, class: 'num', label: '3', fixed: true },
  { key: '4', value: 4, class: 'num', label: '4', fixed: true },
  { key: '5', value: 5, class: 'num', label: '5', fixed: true },
  { key: '6', value: 6, class: 'num', label: '6', fixed: true },
  { key: '7', value: 7, class: 'num', label: '7', fixed: true },
  { key: '8', value: 8, class: 'num', label: '8', fixed: true },
  { key: '9', value: 9, class: 'num', label: '9', fixed: true },
  { key: 'del', value: 'del', class: 'del', label: '', fixed: true },
  { key: '0', value: 0, class: 'num', label: '0', fixed: true },
  { key: 'confirm', value: 'confirm', class: 'confirm', label: '확인' },
  { key: 'dot', value: 'dot', class: 'dot', label: '.' },
  { key: 'moblie', value: '010', class: 'num', label: '010' },
];

function myRandom() {
  return window.crypto.getRandomValues(new Uint32Array(1)) / 4294967296;
}

const SatNumberKeypad = forwardRef((props, ref) => {
  const {
    type,
    title,
    numValue,
    validGuide,
    format,
    dateLength = 8, // 날짜 길이 (8자리/6자리)
    splitter = '.',
    maxLength,
    maxValue,
    useRecommendBtn = '',
    currencyType = 'W',
    keyPadSuffix,
    useDot = false,
    useMobile = false,
    useDate = false,
    decimalPoint = 2,
    dataIndex = '',
    onOk,
    isPrivacy = false,
    isRandomPad = false,
    onChange = () => {},
    onClear = () => {},
    onClose = () => {},
  } = props;

  const { error: toastError } = $hooks.useToast();
  const [inputNumber, setInputNumber] = useState(
    parseFloat(toNumber(numValue)) ? String(numValue).replace(/,/g, '') : '',
    // parseFloat(toNumber(numValue)) ? numValue : '',
  );

  useEffect(() => {
    onChange(inputNumber);
  }, [inputNumber]);

  useImperativeHandle(ref, () => ({
    setInputKeyEvent({ isNumber, keyCode, plainText }) {
      if (isNumber) {
        handleClickKeyPad(parseInt(plainText));
      } else {
        if (isMobile.iOS()) {
          if (keyCode === 42) {
            handleClickKeyPad('del');
          } else if (keyCode === 40) {
            handleClickKeyPad('confirm');
          } else if (keyCode === 55) {
            handleClickKeyPad('dot');
          }
        } else {
          if (keyCode === 67) {
            handleClickKeyPad('del');
          } else if (keyCode === 66) {
            handleClickKeyPad('confirm');
          } else if (keyCode === 56) {
            handleClickKeyPad('dot');
          }
        }
      }
    },
  }));

  const handlePlusValue = amount => {
    if (inputNumber === '') {
      setInputNumber(toCurrency(amount));
    } else {
      setInputNumber(
        $utils.combineKeypadNumber(inputNumber, amount, { decimalPoint }),
      );

      // if (inputNumber.indexOf('.') < 0) {
      //   setInputNumber(
      //     toCurrency(parseInt(toNumber(inputNumber)) + parseInt(amount)),
      //   );
      // } else {
      //   setInputNumber(
      //     toCurrency(toFloatNumber(inputNumber) + toFloatNumber(amount)),
      //   );
      // }
    }
  };

  const handleClickKeyPad = value => {
    const inputValueString = String(value);

    if (typeof value === 'number') {
      let newInputNumber = inputNumber;

      if (inputValueString === '') {
        // 값이 없는 경우
        if (type === 'currency') {
          if (value >= 0) newInputNumber = String(value);
        } else {
          newInputNumber = String(value);
        }
      } else {
        // 값이 있는 경우
        if (inputNumber.indexOf('.') < 0) {
          // 점(.)이 없는 경우
          if (type === 'currency') {
            // 화폐인 경우
            if (inputNumber.charAt(0) !== '0') {
              newInputNumber = $utils.combineKeypadNumber(inputNumber, value, {
                decimalPoint,
                isCombine: true,
              });

              // newInputNumber = toCurrency(
              //   toNumber(inputNumber) + String(value),
              // );
            } else if (inputNumber.charAt(0) === '0' && value > 0) {
              newInputNumber = String(value);
            }
          } else {
            // 화폐가 아닌 경우
            if (type === 'number' && (useMobile || useDate)) {
              if (useMobile) {
                if (inputValueString.length < 12) {
                  newInputNumber = inputNumber + String(value);
                }
              } else if (useDate) {
                const date = toDateNumber(
                  inputNumber + String(value),
                  dateLength,
                  splitter,
                );
                newInputNumber = date.replace(/[^0-9]/g, '');
              }
            } else {
              if (maxLength) {
                if (inputNumber.length < maxLength) {
                  newInputNumber = inputNumber + String(value);
                }
              } else {
                newInputNumber = inputNumber + String(value);
              }
            }
          }
        } else {
          // 점이 있는 경우
          newInputNumber = $utils.combineKeypadNumber(inputNumber, value, {
            decimalPoint,
            isCombine: true,
          });

          // const splitDotArrs = inputNumber.split('.');
          // if (splitDotArrs[1].length < decimalPoint) {
          //   if (type === 'currency') {
          //     newInputNumber = `${toCurrency(toNumber(splitDotArrs[0]))}.${
          //       splitDotArrs[1]
          //     }${String(value)}`;
          //   } else {
          //     newInputNumber = `${splitDotArrs[0]}.${splitDotArrs[1]}${String(
          //       value,
          //     )}`;
          //   }
          // }
        }
      }

      // 유효성 확인 후, 값 변경
      if (!$utils.isNil(maxValue)) {
        const isValidMaxValue = parseFloat(newInputNumber) <= maxValue;
        if (!isValidMaxValue) return toastError('최대값을 초과하였습니다.');
      }

      // 값 변경
      setInputNumber(newInputNumber);
    } else if (value === 'del') {
      if (inputNumber.indexOf('.') < 0) {
        const data = toNumber(inputNumber).substr(
          0,
          toNumber(inputNumber).length - 1,
        );
        if (type === 'currency') {
          if (data === '') setInputNumber(toNumber(data));
          else setInputNumber(toCurrency(data));
        } else {
          setInputNumber(toNumber(data));
        }
      } else {
        setInputNumber(inputNumber.slice(0, -1));

        // const splitDotArrs = inputNumber.split('.');
        // if (splitDotArrs[1] === '') {
        //   setInputNumber(splitDotArrs[0]);
        // } else {
        //   setInputNumber(
        //     `${splitDotArrs[0]}.${splitDotArrs[1].substr(
        //       0,
        //       splitDotArrs[1].length - 1,
        //     )}`,
        //   );
        // }
      }
    } else if (value === 'dot') {
      if (!$utils.isEmptyString(inputNumber) && !inputNumber.includes('.')) {
        setInputNumber(`${inputNumber}.`);
      }
    } else if (value === '010') {
      if (type === 'number') {
        if (!inputNumber.startsWith('010')) {
          setInputNumber('010');
        }
      }
    } else {
      if (inputNumber === '') {
        if (type === 'currency') {
          if (useDot) {
            onOk(`0.${Array(decimalPoint).fill('0').join('')}`);
          } else {
            onOk('0');
          }
        } else {
          onOk('');
        }
      } else {
        if (useDot) {
          if (!inputNumber.includes('.')) {
            onOk(`${inputNumber}.${Array(decimalPoint).fill('0').join('')}`);
          } else {
            const splitDotArrs = inputNumber.split('.');
            if (splitDotArrs[1].length !== decimalPoint) {
              if (decimalPoint > splitDotArrs[1].length) {
                onOk(
                  `${splitDotArrs[0]}.${splitDotArrs[1]}${Array(
                    decimalPoint - splitDotArrs[1].length,
                  )
                    .fill('0')
                    .join('')}`,
                );
              } else {
                onOk(
                  `${splitDotArrs[0]}.${splitDotArrs[1].substr(
                    0,
                    decimalPoint,
                  )}`,
                );
              }
            } else {
              onOk(inputNumber);
            }
          }
        } else {
          if (useMobile) {
            onOk(toPhoneNumber(inputNumber).replace(/[^0-9]/g, ''));
          } else if (useDate) {
            onOk(
              toDateNumber(inputNumber, dateLength, splitter).replace(
                /[^0-9]/g,
                '',
              ),
            );
          } else {
            onOk(inputNumber);
          }
        }
      }
    }
  };

  const handleDeleteValue = () => {
    setInputNumber('');
    if (typeof onClear === 'function') onClear();
  };

  const getStyleClass = () => {
    let className = '';

    if (type === 'currency' || type === 'percent') className += 'inp-right ';
    if (inputNumber !== '') className += 'on ';

    return className;
  };

  const checkDisabled = () => {
    let isDisabled = false;

    const displayValue = useMobile
      ? toPhoneNumber(inputNumber)
      : useDate
      ? toDateNumber(inputNumber, dateLength, splitter)
      : inputNumber;
    const inputValue = displayValue.replace(/-/g, '');

    if (format === 'phone') {
      const isValidFormat = $utils.checkValidPhoneNumber(inputValue);
      isDisabled = !isValidFormat;
    }

    return isDisabled;
  };

  const handleKeyStroke = key => {
    if (/[0-9]/g.test(key)) {
      handleClickKeyPad(Number(key));
    } else if (key === '.') {
      handleClickKeyPad('dot');
    } else if (key === 'Backspace') {
      handleClickKeyPad('del');
    } else if (key === 'Enter') {
      handleClickKeyPad('confirm');
    } else if (key === 'Escape') {
      onClose(inputNumber);
    }
  };

  // 키패드 입력 추가
  $hooks.useKeyStroke({
    target: 'numberKeyPad',
    value: inputNumber,
    onKeyStroke: handleKeyStroke,
  });

  return (
    <>
      {type === 'number' && title !== '' && (
        <h3 className="layer-tit2">{title}</h3>
      )}

      {isPrivacy ? (
        <div className="input-hidden-wrap">
          <div className="input-hidden-box">
            <ul className="input-box-group">
              {new Array(parseInt(maxLength)).fill('').map((input, index) => (
                <li className={inputNumber[index] ? 'end' : ''} key={index}>
                  <span className="input"></span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : (
        <div className={`keypad-input-wrap ${getStyleClass()}`}>
          <div className="input-text">
            {inputNumber === '' ? (
              <>
                {keyPadSuffix ? (
                  <span>{keyPadSuffix}</span>
                ) : (
                  type === 'currency' && <span>금액을 입력</span>
                )}
              </>
            ) : (
              <>
                <p className="input-num">
                  <strong>
                    {useMobile
                      ? toPhoneNumber(inputNumber)
                      : useDate
                      ? toDateNumber(inputNumber, dateLength, splitter)
                      : type === 'currency'
                      ? toCurrency(
                          inputNumber,
                          String(inputNumber).split('.')[1]?.length,
                        )
                      : inputNumber}
                  </strong>

                  {keyPadSuffix ? (
                    <span>{keyPadSuffix}</span>
                  ) : type === 'currency' ? (
                    <span>
                      {currencyType === 'W'
                        ? dataIndex === 'faceAmount'
                          ? '만원'
                          : '원'
                        : '달러'}
                    </span>
                  ) : (
                    type === 'percent' && <span>%</span>
                  )}
                </p>

                <SatButton
                  styleClass={`ico ico-del ${inputNumber !== '' && 'on'}`}
                  onClick={handleDeleteValue}
                />
              </>
            )}
          </div>
        </div>
      )}

      {type === 'currency' && useRecommendBtn !== '' && (
        <div className="plus-wrap">
          {(currencyType === 'W'
            ? useRecommendBtn === 'faceAmount'
              ? RECOMMEND_WON_FACEAMOUNT
              : RECOMMEND_WON_PREMIUM
            : useRecommendBtn === 'faceAmount'
            ? RECOMMEND_DOLLAR_FACEAMOUNT
            : RECOMMEND_DOLLAR_PREMIUM
          ).map((amount, index) => {
            return (
              <SatButton
                key={index}
                styleClass="btn-s"
                label={
                  currencyType === 'W' && useRecommendBtn === 'premium'
                    ? `+${Number(amount) / 10000}만`
                    : `+${toCurrency(amount)}`
                }
                onClick={() => handlePlusValue(amount)}
              />
            );
          })}
        </div>
      )}

      {((useDot && type === 'currency') || validGuide.length > 0) && (
        <div className="text-info-wrap">
          {useDot && type === 'currency' ? (
            <p className="text-info ico-type">
              센트단위는 '.' 선택후 숫자를 입력해주세요.
            </p>
          ) : (
            ''
          )}
          {validGuide.length > 0 &&
            validGuide.map((guide, idx, arr) => {
              if (idx === arr.length - 1) {
                return <p className="text-info ico-type">{guide.guideMsg}</p>;
              } else {
                return (
                  <React.Fragment key={`guide_${idx}`}>
                    <p className="text-info ico-type">{guide.guideMsg}</p>
                    <br />
                  </React.Fragment>
                );
              }
            })}
        </div>
      )}

      <Keypad
        useDot={useDot}
        useMobile={useMobile}
        isRandomPad={isRandomPad}
        handleClickKeyPad={handleClickKeyPad}
      />

      {(useDot || useMobile) && (
        <div className="mgt-16 mgl-16 mgr-16">
          <SatButton
            disabled={checkDisabled()}
            styleClass="btn-l blue"
            label={'확인'}
            onClick={() => handleClickKeyPad('confirm')}
          />
        </div>
      )}
    </>
  );
});

const Keypad = ({ useDot, useMobile, isRandomPad, handleClickKeyPad }) => {
  const [keyPadButtons, setKeypadButtons] = useState(null);

  if (!keyPadButtons) {
    const newKeyPadButtons = KEY_PAD.filter(keyPad => keyPad.fixed)
      .concat(
        KEY_PAD.filter(
          keyPad =>
            keyPad.key === (useDot ? 'dot' : useMobile ? 'moblie' : 'confirm'),
        ),
      )
      // [Robin]: 랜덤 키패드 일 경우 추가
      .reduce((_, keyPad, index, originalKeyPads) => {
        const getRandomIndex = arr => {
          if (!Array.isArray(arr)) return -1;

          const itemCount = arr.length;
          let randomIndex = Math.floor(myRandom() * itemCount);
          const randomIndexItem = arr[randomIndex];
          const isNumber = typeof randomIndexItem.value === 'number';
          if (!isNumber) randomIndex = getRandomIndex(arr);

          return randomIndex;
        };

        const isNumberKeyPad = typeof keyPad.value === 'number';
        if (isRandomPad && isNumberKeyPad) {
          const randomNumberKeyPadIndex = getRandomIndex(originalKeyPads);
          const randomIndexItem = originalKeyPads[randomNumberKeyPadIndex];

          // Swap the items with the randomIndex
          originalKeyPads.splice(index, 1, randomIndexItem);
          originalKeyPads.splice(randomNumberKeyPadIndex, 1, keyPad);
        }

        return originalKeyPads;
      });

    setKeypadButtons(newKeyPadButtons);
  }

  return (
    <div className="keypad-area">
      {keyPadButtons?.map(keyPad => {
        return (
          <SatButton
            key={keyPad.key}
            styleClass={`btn-keypad ${keyPad.class}`}
            label={keyPad.label}
            onClick={() => handleClickKeyPad(keyPad.value)}
            iconStyleClass={keyPad.class === 'del' && 'ico ico-del2'}
          />
        );
      })}
    </div>
  );
};

export default SatNumberKeypad;
